import React, { useContext } from 'react'
import { Claim } from 'src/components/Claim'
import { Spinner } from 'src/components/Spinner'
import { ArcContext } from 'src/contexts/ArcContext'
import { distribution } from './ClaimAllocation'
import { distribution as distribution2 } from './ClaimAllocation2'

interface IClaimPage {
  phase?: number
}

export function ClaimPage({ phase = 1 }: IClaimPage) {
  const { arc } = useContext(ArcContext)
  if (!arc) {
    return (
      <div className="page">
        <Spinner />
      </div>
    )
  }

  switch (phase) {
    case 1:
      return (
        <div className="page">
          <Claim
            distribution={distribution}
            distributorAddress="0x562423f830582B6F704E175c439E132e59058284"
          />
        </div>
      )
    case 2:
      return (
        <div className="page">
          <Claim
            distribution={distribution2}
            distributorAddress="0x79822A9696b11bCDF9380d4eF56b7566509E98aB"
          />
        </div>
      )
    default:
      throw new Error(`Invalid phase: ${phase}`)
  }
}
